const columnValidationWarning = {
  heading: "Dálkaheiti þarfnast athugunar",
  intro: {
    important: "Mikilvægt:",
    text: "Sumir dálkar fundust ekki nákvæmlega eins og tilgreint var. Vinnsla með vantandi dálkum gæti leitt til",
    exposureWarning: "óviljandi birtingar persónuupplýsinga",
    suffix: "Vinsamlegast farðu yfir og lagaðu dálkaheitin hér fyrir neðan.",
  },
  columnNotFound: "Dálkur fannst ekki:",
  didYouMean: "Áttirðu við eitthvað af þessu?",
  percentSimilar: "{{percent}}% líkt",
  noSimilarFound: "Engir svipaðir dálkar fundust. Tiltækir dálkar:",
  fixColumnNames: "Laga dálkaheiti",
  proceedAnyway: "⚠️ Halda samt áfram (áhætta: birting persónuupplýsinga)",
  proTip: {
    label: "💡 Góð regla:",
    text: "Dálkapörun er óháð há-/lágstöfum og hunsar auka bil. Prófaðu:",
  },
};

export default columnValidationWarning;
